// Configuration for all picklist tables in the system
// Add new picklists here as they are created

export interface PicklistConfig {
  id: string;
  name: string;
  tableName: string;
  description?: string;
  placeholderExample?: string; // Example value for placeholder text
}

export const picklists: PicklistConfig[] = [
  {
    id: 'basins',
    name: 'Basins',
    tableName: 'list_basins',
    description: 'Geographic basins for operations',
    placeholderExample: 'Permian Basin',
  },
  {
    id: 'regions',
    name: 'Regions',
    tableName: 'list_regions',
    description: 'Geographic regions for operations',
    placeholderExample: 'North American Land',
  },
  {
    id: 'segments',
    name: 'Segments',
    tableName: 'list_segments',
    description: 'Business segments for categorization',
    placeholderExample: 'Drilling',
  },
];
